<template>
</template>

<script>

import {mapGetters} from 'vuex'

export default {
    data(){
        return {
            button:null,
        }
    },
    components:{
    },
    computed: {
        ...mapGetters([
            'productShow'
        ]),
        typeDialog:{
            get(){
                return this.$store.state.typeDialog
            },
            set(v){
                this.$store.state.typeDialog = v
            }
        },
        productDialog:{
            get(){
                return this.$store.state.productDialog
            },
            set(v){
                this.$store.state.productDialog = v
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .teste{
        height: 80vh;
    }
</style>